var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"permalink",class:{small: _vm.small},attrs:{"to":_vm.permalink},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.desc))])}
var staticRenderFns = []

export { render, staticRenderFns }